import Vue from 'vue'
import {ptracGetEntities} from 'src/utilities/ptracApi'
import {make} from 'vuex-pathify'
import {hydrateEdit, resetState, savePayload} from 'src/utilities/vuex2'
import {OK} from 'http-status-codes'
import {objectById, sortBy} from '@/utilities/utils'
import _ from 'lodash'
import {ObjectId} from 'bson'

const initialState = {
  edit: {
    id: null,
    inspectionTypes: [],
    fields: [],
    active: true
  },
  tabIndex: {
    inspectionType: 0,
    category: 0
  }
}

const state = Vue.util.extend({}, JSON.parse(JSON.stringify(initialState)))

const getters = make.getters(state)
getters.savePayload = savePayload

const mutations = make.mutations(state)
mutations.reset = resetState
mutations.hydrateEdit = hydrateEdit
mutations.resetEdit = (state) => {
  state.edit = JSON.parse(JSON.stringify(initialState.edit))
}
mutations.addField = (state, field) => {
  if (!state.edit.fields) {
    state.edit.fields = []
  }

  state.edit.fields.push(field)
}
mutations.removeField = (state, fieldToDelete) => {
  state.edit.fields = _.filter(state.edit.fields, (field) => field.key !== fieldToDelete.key)
}

mutations.addInspectionType = (state, inspectionType) => {
  state.edit.inspectionTypes.push({
    title: inspectionType,
    name: inspectionType,
    sort: state.edit.inspectionTypes.length + 1
  })

  state.tabIndex.inspectionType = state.edit.inspectionTypes.length - 1
}
mutations.removeInspectionType = (state, inspectionTypeToRemove) => {
  const inspectionTypes = state.edit.inspectionTypes
  state.edit.inspectionTypes = inspectionTypes.filter(inspectionType => inspectionType.name !== inspectionTypeToRemove)
  state.tabIndex.inspectionType = state.tabIndex.inspectionType - 1
}

mutations.addCategory = (state, category) => {
  if (!state.edit.inspectionTypes[state.tabIndex.inspectionType].categories) {
    state.edit.inspectionTypes[state.tabIndex.inspectionType].categories = []
  }

  const inspectionCategoryTabIndex = state.edit.inspectionTypes[state.tabIndex.inspectionType].categories.length

  state.edit.inspectionTypes[state.tabIndex.inspectionType].categories.push({
    title: category,
    name: category,
    sort: inspectionCategoryTabIndex + 1
  })

  state.tabIndex.category = inspectionCategoryTabIndex
}
mutations.removeCategory = (state, categoryToRemove) => {
  const categories = state.edit.inspectionTypes[state.tabIndex.inspectionType].categories
  state.edit.inspectionTypes[state.tabIndex.inspectionType].categories = categories.filter(category => category.name !== categoryToRemove)
  state.tabIndex.category = state.tabIndex.category - 1
}

mutations.addComment = (state, comment) => {
  const activeCategory = state.edit.inspectionTypes[state.tabIndex.inspectionType].categories[state.tabIndex.category]

  if (!activeCategory.comments) {
    activeCategory.comments = []
  }

  activeCategory.comments.push({
    id: new ObjectId().toHexString(), // ok to ignore missing id property
    value: comment,
  })

  // sort alphabetically
  activeCategory.comments = sortBy(activeCategory.comments, 'value')
}

mutations.editComment = (state, commentToEdit) => {
  const comments = state.edit.inspectionTypes[state.tabIndex.inspectionType].categories[state.tabIndex.category].comments
  const comment = objectById(comments, commentToEdit.id)
  if (comment) {
    comment.value = commentToEdit.value
  }
}

mutations.removeComment = (state, commentToRemove) => {
  const comments = state.edit.inspectionTypes[state.tabIndex.inspectionType].categories[state.tabIndex.category].comments
  state.edit.inspectionTypes[state.tabIndex.inspectionType].categories[state.tabIndex.category].comments =
    comments.filter(comment => comment.id !== commentToRemove.id)
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions: {
    async fetchDigitalForm({ state }) {
      const response = await ptracGetEntities('digital-forms-v2', 'digitalFormV2s')

      if (OK === response.status && response.data.length > 0) {
        hydrateEdit(state, response.data[0])
      }

      return response
    }
  }
}
